if (!window.Eurus.loadedScript.has('map.js')) {
  window.Eurus.loadedScript.add('map.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xMap", (data) => ({
        load() {
          const address = data || this.$el.dataset.address || '';
          if (!address) return;
          const query = encodeURIComponent(address);
          const iframe = this.$el.querySelector("iframe");
          if (iframe) {
            iframe.src = `https://maps.google.com/maps?q=${query}&t=m&z=17&ie=UTF8&output=embed&iwloc=near`;
          }
        },
        loadMap(location) {
          if (!location) return;
          const query = encodeURIComponent(location);
          const iframe = this.$el.querySelector("iframe");
          if (iframe) {
            iframe.src = `https://maps.google.com/maps?q=${query}&t=m&z=17&ie=UTF8&output=embed&iwloc=near`;
          }
        },
        removeMap() {
          const iframe = this.$el.querySelector("iframe");
          if (iframe) {
            iframe.src = ``;
          }
        } 
      }));
    });
  });
}